export const types = {
  SET_LOADING: "SET_LOADING",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  SET_MARKET_CONFIG: "SET_MARKET_CONFIG",
};

const initialState = {
  loading: false,
  menuVisible: true,
  marketConfig: null,
};

export default function app(state = initialState, action) {
  switch (action.type) {
    case types.SET_LOADING:
      return { ...state, ...action.payload };
    case types.TOGGLE_SIDEBAR:
      return { ...state, menuVisible: !state.menuVisible };
    case types.SET_MARKET_CONFIG:
      return { ...state, marketConfig: action.payload };
    default:
      return state;
  }
}
